import { ApplicationController } from "../application_controller";


// The tourist voucher form: the welcome sign, the tourists and the flights follow the chosen partner.
// The data of every partner is rendered in the "partner" targets, so the other fields are kept as typed.
export default class extends ApplicationController {
  static targets = ["welcomeSign", "tourists", "partner"]


  selectPartner(event) {
    const partnerId = event.target.value;

    this.partnerTargets.forEach((partner) => {
      const selected = partner.dataset.partnerId === partnerId;

      partner.classList.toggle("d-none", !selected);
      if (selected) {
        this.welcomeSignTarget.value = partner.dataset.welcomeSign;
        this.touristsTarget.value = partner.dataset.tourists;
      }
    });
  }
}
